import './product_selection.css';
import { randomId } from "../../common/randomId";
import { useSingleProduct } from '../../context/SingleProductContext';

export const ProductSelection = ({option}) => {
    //HOOKS
    const { options, setSelectionChoice, optionsErrors } = useSingleProduct();

    //EVENT HANDLERS
    const handleChoiceChange = (e) => {
        setSelectionChoice(option.id, e.target.value);
    }

    return (
        <div className='product_selection_container'>
            <h2>
                {option.name}
            </h2>
            <div className='product_selection_options_container'>
                <p>
                    Select an option
                </p>
                <span className='error_msg'>
                    { optionsErrors[option.id] ?? optionsErrors[option.id] }
                </span>
                <div className='product_selection_radio_container'>
                    {
                        options && options[option.id] && option.choices.map(choice => {
                            let id = randomId(100);
                            return (
                                <div className='option_container' key={'option_' + option.id + "choice_" + choice.id}>
                                    <input
                                        type="radio" 
                                        value={choice.id} 
                                        checked={options[option.id].choice === choice.id} 
                                        id={'option_' + id}
                                        name={'option_'+option.id + '_input'}
                                        onChange={handleChoiceChange}
                                    />
                                    <label htmlFor={'option_' + id}>{choice.name} +${choice.price / 100}</label>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        </div>
    );
}